import PageHeader from 'components/layout/page-header'
import { useReportsTopNavigationLinks } from './hooks/use-reports-top-navigation-links'
import { SavedReportsTable } from 'components/timenotes/saved-reports/saved-reports-table'
import { SavedReportsFilters, useSavedReportsFilters } from './components/saved-reports-filters'

export function SavedReportsPage() {
  useReportsTopNavigationLinks()

  const [filters, setFilters] = useSavedReportsFilters()

  return (
    <>
      <div className="page-content">
        <PageHeader
          title="Saved Reports"
          buttons={[]}
        />
      </div>

      <div className="page-content" style={{ marginLeft: '5px', marginRight: '5px' }}>
        <SavedReportsFilters
          initialValues={filters}
          onFiltersChange={(newFilters) => {
            setFilters(prev => ({
              ...prev,
              name: newFilters.name,
              visibility: newFilters.visibility
            }))
          }}
        />
        
        <div style={{ marginTop: '1rem' }}>
          <SavedReportsTable 
            filters={filters}
          />
        </div>
      </div>
    </>
  )
}